import { serviceMessageError } from "../utils/common";
import { showValidateErrors } from "./showValidateErrors";
import WarningIcon from "@mui/icons-material/Warning";
import { toast } from "react-toastify";
import i18n from "../config/languageInit";
import errorNormalize from "./errorNormalize";
/**
 *
 * @param {AxiosError} error
 */
export function handleAxiosError(error) {
  switch (error.response.status) {
    case 400:
      if (typeof error.response?.data === "string") {
        toast.error(error.response?.data);
      } else if (typeof error.response?.data?.message === "string") {
        toast.error(error.response.data.message);
      } else toast.error(error.response.message);
      if (error.response.data.errors)
        showValidateErrors(error.response.data.errors);
      break;
    case 404:
      toast.error("Bulunamadı");
      break;
    case 405:
      if (process.env.NODE_ENV !== "production")
        toast.error(
          `${error.response.config.baseURL}/${error.response.config.url} adresine ${error.response.config.method} isteği izin verilmedi`
        );
      else toast.error(i18n.t("not_found"));
      break;
    case 401:
      serviceMessageError(
        i18n.t("unauthorized_request"),
        <WarningIcon color="warning" />
      );
      break;
    case 403:
      serviceMessageError(i18n.t("forbidden_request"));
      break;
    case 500:
      if (
        error.response.data?.Message &&
        typeof error.response.data.Message === "string"
      ) {
        var errors = errorNormalize(error.response.data.Message);
        errors.forEach((e) => toast.error(e));
      } else toast.error(i18n.t("error"));
      break;
    default:
      toast.error(i18n.t("error"));
  }
}
